import axios from '@axios'
export const state = {
  operators: [],
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 1,
}

export const getters = {
  allOperators: (state) => state.operators,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_OPERATORS: (state, data) => {
    state.operators = data.operators
    state.currentPage = data.page
    state.perPage = data.perPage
    state.totalPages = data.totalPages
    state.totalRecords = data.totalRecords
  },
  CREATE_OPERATOR: (state, operator) => {
    state.operators.unshift(operator)
  },
  UPDATE_OPERATOR: (state, operator) => {
    state.operators = state.operators.filter((ops) => ops.id !== operator.id)
    state.operators.unshift(operator)
  },
  REMOVE_OPERATOR: (state, operator) => {
    state.operators = state.operators.filter((ops) => ops.id !== operator.id)
  },
  CREATE_MCC_MNC: (state, mccMnc) => {
    state.operators.forEach((ops, index) => {
      if (ops.id === mccMnc.operator_id) {
        state.operators[index].mcc_mncs.push({
          id: mccMnc.id,
          mcc: mccMnc.mcc,
          mnc: mccMnc.mnc,
        })
      }
    })
  },
  REMOVE_MCC_MNC: (state, mccMnc) => {
    state.operators.forEach((ops, index) => {
      if (ops.id === mccMnc.operator_id) {
        let newMccMnc = ops.mcc_mncs.filter((mm) => mm.id !== mccMnc.id)
        state.operators[index].mcc_mncs = newMccMnc
      }
    })
  },
  UPDATE_MCC_MNC: (state, mccMnc) => {
    state.operators.forEach((ops, index) => {
      if (ops.id === mccMnc.operator_id) {
        let updatedMccMnc = ops.mcc_mncs.filter((mm) => mm.id !== mccMnc.id)
        updatedMccMnc.unshift(mccMnc)
        state.operators[index].mcc_mncs = updatedMccMnc
      }
    })
  },
  CREATE_PREFIX: (state, prefix) => {
    state.operators.filter((ops, index) => {
      if (ops.id === prefix.operator_id) {
        state.operators[index].prefixs.unshift(prefix)
      }
    })
  },
  REMOVE_PREFIX: (state, prefix) => {
    state.operators.forEach((ops, index) => {
      if (ops.id === prefix.operator_id) {
        state.operators[index].prefixs = ops.prefixs.filter(
          (p) => p.id !== prefix.id
        )
      }
    })
  },
  UPDATE_PREFIX: (state, prefix) => {
    state.operators.filter((ops, index) => {
      if (ops.id === prefix.operator_id) {
        let newPrefixs = ops.prefixs.filter((pre) => pre.id !== prefix.id)
        newPrefixs.unshift(prefix)
        state.operators[index].prefixs = newPrefixs
      }
    })
  },
}
export const actions = {

  async getOperators({ commit }, params = {}) {
    let { _commit } = params
    if (typeof (_commit) === 'boolean' && _commit === false) return axios.get('/sms/operators', { params: params })
    await axios.get('/sms/operators', { params: params }).then(resp => {
      if (resp.status === 200) {
        commit("GET_OPERATORS", resp.data)
      }
    })
  },
  async getOperator({ commit }, operator) {
    return axios.get(`/sms/operator/${operator.id}`)
  },
  async createOperator({ commit }, operator) {
    await axios
      .post('/sms/operator', operator)
      .then(response => {
        if (response.status === 201) {
          commit('CREATE_OPERATOR', response.data)
        }
      })
  },
  async updateOperator({ commit }, operator) {
    await axios
      .put(`/sms/operator/${operator.id}`, operator)
      .then((resp) => {
        if (resp.status === 200) {
          commit('UPDATE_OPERATOR', resp.data)
        }
      })
  },
  async removeOperator({ commit }, operator) {
    await axios
      .delete(`sms/operator/${operator.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_OPERATOR', operator)
        }
      })
  },
  async createMccMnc({ commit }, mccMnc) {

    await axios
      .post('/sms/operator/mcc-mnc', mccMnc)
      .then((resp) => {
        if (resp.status === 200) {
        };

      })
  },
  async updateMccMnc({ commit }, mccMnc) {
    await axios
      .put(`/sms/operator/mcc-mnc/${mccMnc.id}`, mccMnc)
      .then((resp) => {
        if (resp.status === 200) {
          commit('UPDATE_MCC_MNC', mccMnc)
        }
      })
  },
  async removeMccMnc({ commit }, mccMnc) {
    await axios
      .delete(`/sms/operator/mcc-mnc/${mccMnc.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_MCC_MNC', mccMnc)
        }
      })
  },
  async createPrefix({ commit }, prefix) {
    await axios
      .post('/sms/operator/prefix', prefix)
      .then((resp) => {
        if (resp.status === 200) {
          let newPrefix = Object.assign(resp.data, {
            operator_id: prefix.operator_id,
          })
          commit('CREATE_PREFIX', newPrefix)
        }
      })
  },
  async removePrefix({ commit }, prefix) {
    await axios
      .delete(`/sms/operator/prefix/${prefix.id}`)
      .then((resp) => {
        if (resp.status === 204) {
          commit('REMOVE_PREFIX', prefix)
        }
      })
  },
  async updatePrefix({ commit }, prefix) {
    await axios
      .put(`/sms/operator/prefix/${prefix.id}`, prefix)
      .then((resp) => {
        if (resp.status === 200) {
        }
      })
  },
}